(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionPageDetailController', DocumentVersionPageDetailController);

    DocumentVersionPageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'DocumentVersionPage', 'DocumentVersion'];

    function DocumentVersionPageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, DocumentVersionPage, DocumentVersion) {
        var vm = this;

        vm.documentVersionPage = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentVersionPageUpdate', function(event, result) {
            vm.documentVersionPage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
